import { render } from "./AccessibilityFilters.vue?vue&type=template&id=24a84d8c"
import script from "./AccessibilityFilters.vue?vue&type=script&lang=js"
export * from "./AccessibilityFilters.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francoisgillet/Documents/GitHub/tenjity-module/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__